import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// App Check (reCAPTCHA v3) protege login/registro contra bots e abuso
// automatizado. Só é ativado se a site key existir, para não quebrar
// ambientes (dev/preview) onde ela ainda não foi configurada no Firebase
// Console. Ver .env.example para instruções.
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  // Precisa vir ANTES do initializeAppCheck. Em desenvolvimento o reCAPTCHA não
  // valida localhost, então sem isto o app para de falar com o Firestore assim
  // que o enforcement for ligado no console.
  //
  // Sem VITE_APPCHECK_DEBUG_TOKEN, o SDK gera um token novo a cada sessão e o
  // imprime no console do navegador — você cadastra em App Check > Apps >
  // Gerenciar tokens de depuração. Definindo a variável, o token fica fixo e
  // você cadastra uma vez só. Ela nunca é lida em build de produção.
  if (import.meta.env.DEV) {
    (
      self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string | boolean }
    ).FIREBASE_APPCHECK_DEBUG_TOKEN =
      import.meta.env.VITE_APPCHECK_DEBUG_TOKEN || true;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}
